import { useAuth } from '@context/AuthContext'
import PageLoader from '@components/PageLoader'
import { useTrips } from '@hooks'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HomeContainer } from './HomePage.styles'

/**
 * Post-login landing hop. A member of exactly one trip is dropped straight into
 * it — the trips list would be a one-card waiting room. Everyone else (none,
 * several, or a failed fetch) lands on the list, which is still reachable from
 * the nav, so the shortcut never traps a single-trip member there.
 */
const HomePage: React.FC = () => {
	const navigate = useNavigate()
	const { user } = useAuth()
	const { data, isLoading, error } = useTrips()

	React.useEffect(() => {
		if (isLoading) return
		const trips = data?.trips ?? []
		if (!error && trips.length === 1) {
			navigate(`/trips/${trips[0].id}`, { replace: true })
			return
		}
		navigate('/trips', { replace: true })
	}, [navigate, data, isLoading, error])

	return (
		<HomeContainer>
			<h1>Welcome back, {user?.firstName}!</h1>
			<PageLoader label="Loading your trips…" />
		</HomeContainer>
	)
}

export default HomePage
